module.exports = __webpack_public_path__ + "img/d3398a5.jpg";